import * as Yup from "yup";

export const packingMethods = {
    lumpsum: {
        id: "lumpsum",
        description: "Aggregate all items into packages at one times settings"
    },
    existing: {
        id: "existing",
        description: "Use Existing Package to Pack"
    },
    new: {
        id: "new",
        description: "Create new package for packing"
    }
}


export const buildAddressKey = ({ data }) => {

    let { document } = data

    let keys = ["delivery_address_1", "delivery_address_2", "delivery_area_name"]
    
    let addressKeyArray = keys.map(i => {

        let s = document[i]

        s = s? s.replace(/ /g, ' ') : ""

        return s.toLowerCase().toUpperCase()
    })

    return addressKeyArray.join("::")

}

export const validateRowSchema = Yup.object().shape({
    documentId: Yup
        .string()
        .required("Required"),
    itemId: Yup
        .string()
        .required("Required"),
    qty: Yup.lazy((val) => {

        let maxQty = val?.maxQty? val.maxQty : 0
        let itemQty = val?.itemQty? val.itemQty : 0

        let valueSchema;

        valueSchema = Yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            // .positive("More than 0")
            .required("Required")

        return Yup.object().shape({
            value: valueSchema,
            maxQty: Yup.mixed().nullable().typeError("Invalid")
        })
            

    }),
    // data: Yup
    //     .mixed()
    //     .required("Required"),
})


export const validationSchema = Yup.object({
    rows: Yup.array().of(validateRowSchema),
    locationId: Yup
        .string()
        .required("Required"),
    package: Yup.lazy((val) => {

        let method = val?.method? val.method : ''
        
        // let valueSchema;

        if(method === packingMethods.new.id){
            
            return Yup.object().shape({
                method: Yup
                    .string()
                    .oneOf(Object.keys(packingMethods))
                    .required("Required"),
                uomId: Yup
                    .string()
                    .required("Required"),
                remark: Yup
                    .string()
                    .required("Required")
            })

        }
        
        if(method === packingMethods.existing.id){
            return Yup.object().shape({
                method: Yup
                    .string()
                    .oneOf(Object.keys(packingMethods))
                    .required("Required"),
                packageNo: Yup
                    .string()
                    .required("Required"),
                remark: Yup
                    .string()
                    .required("Required"),
            })
        }
        
        if(method === packingMethods.lumpsum.id){

            let validateRowLumpsumSchema = Yup.object().shape({
                uomId: Yup
                    .string()
                    .required("Required"),
                uomName: Yup
                    .string()
                    .required("Required"),
                qty: Yup
                    .number("")
                    .typeError("Invalid")
                    // .min(parseFloat(minQty))
                    // .max(parseFloat(maxQty), `Max : ${maxQty}`)
                    // .positive("More than 0")
                    .required("Required"),
            })

            return Yup.object().shape({
                method: Yup
                    .string()
                    .oneOf(Object.keys(packingMethods))
                    .required("Required"),
                remark: Yup
                    .string()
                    .required("Required"),
                packages: Yup.array().of(validateRowLumpsumSchema)
            })
        }

        return Yup.object().shape({})

    }),
})

export const initialRowValues = {
    documentId: 0,
    documentDate: "",
    documentNumber: "",
    docItemId: "",
    itemId: "",
    qty: {
        maxQty: "0",
        value: "0",
        itemQty: "0"
    },
    name: "",
    code: "",
    description: "",
    uomId: "",
    uomName: "",
    price: "",
}

export const initialPackagePackagesRowValues = {
    uomId: "",
    uomName: "",
    qty: ""
}

export const initialValues = {
    filterDocumentId: "all",
    searchPackageNo: "",
    locationId: "",
    locationDisplay: "",
    rows: [],
    // packingMethod: packingMethods.new.id,
    package: {
        method: packingMethods.new.id,
        uomId: "",
        uomName: "",
        remark: "",
        packageNo: "",
        packages: [initialPackagePackagesRowValues]
    }
    // packages: []
}
